export const getCurrentDate = () => new Date();

export const getCurrentTime = () => getCurrentDate().getTime();

export const getCurrentYear = () => getCurrentDate().getFullYear();



// WEBPACK FOOTER //
// /src/js/common/utils/currentDate.js